import Layout from "../../../components/Layout";
import { Dashboard } from "../Dashboard";

export function PerguntaDiariaView() {
  return Layout(Dashboard, "Pergunta Diária");
}
